"use client"

import { FileText, Presentation, StickyNote, Download,  } from "lucide-react"

interface Resource {
  id: string
  type: "pdf" | "presentation" | "notes" | "quiz" | "flashcards"
  title: string
}

interface ResourcesSectionProps {
  resources: Resource[]
  onResourceClick?: (resource: Resource) => void
}

export function ResourcesSection({ resources, onResourceClick }: ResourcesSectionProps) {
  const getIcon = (type: Resource["type"]) => {
    switch (type) {
      case "pdf":
        return <FileText className="w-5 h-5" />
      case "presentation":
        return <Presentation className="w-5 h-5" />
      case "notes":
  return <StickyNote className="w-5 h-5" />
      case "quiz":
        return <Download className="w-5 h-5" />
      case "flashcards":
        return <StickyNote className="w-5 h-5" />
        
      default:
        return <FileText className="w-5 h-5" />
    }
  }

  const getTypeColor = (type: Resource["type"]) => {
    switch (type) {
      case "pdf":
        return "bg-red-100 text-red-600"
      case "presentation":
        return "bg-blue-100 text-blue-600"
      case "notes":
        return "bg-green-100 text-green-600"
      case "quiz":
        return "bg-purple-100 text-purple-600"
      case "flashcards":
        return "bg-orange-100 text-orange-600"
      default:
        return "bg-gray-100 text-gray-600"
    }
  }

  const handleResourceClick = (resource: Resource) => {
    if (onResourceClick) {
      onResourceClick(resource)
    }
  }

  return (
    <div className="bg-slate-100 rounded-lg border border-slate-200">
      <div className="p-4 border-b border-slate-200">
        <h3 className="text-lg font-semibold text-slate-900">Resources</h3>
        <p className="text-sm text-slate-600">Supplementary materials for this lesson</p>
      </div>
      
      <div className="p-4 space-y-3">
        {resources.map((resource) => (
          <button
            key={resource.id}
            onClick={() => handleResourceClick(resource)}
            className="w-full flex items-center gap-3 p-3 rounded-lg border border-slate-200 hover:border-slate-300 hover:bg-slate-50 transition-colors text-left group"
          >
            <div className={`p-2 rounded-lg ${getTypeColor(resource.type)}`}>
              {getIcon(resource.type)}
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="font-medium text-slate-900 truncate group-hover:text-blue-600 transition-colors">
                {resource.title}
              </p>
              <p className="text-sm text-slate-500 capitalize">
                {resource.type} • Click to view
              </p>
            </div>
            
            <div className="opacity-0 group-hover:opacity-100 transition-opacity">
              <Download className="w-4 h-4 text-slate-400" />
            </div>
          </button>
        ))}
        
        {resources.length === 0 && (
          <div className="text-center py-8 text-slate-500">
            <FileText className="w-12 h-12 mx-auto mb-3 opacity-50" />
            <p>No resources available for this lesson</p>
          </div>
        )}
      </div>
    </div>
  )
}